import React, {Component, useState} from 'react';
import toastr from "toastr";
import axios from "axios";
import http from "../../services/httpService";
import {getCurrentUserName, setCurrentUserName, getCurrentUserId, getJwt} from "../../services/authService";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {Picker} from 'emoji-mart'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import {Intent, Position, Callout, Popover, PopoverInteractionKind} from "@blueprintjs/core";

import $ from 'jquery';
import EmojiTextArea from '../common/EmojiTextArea';
import CustomSinglePostPreview from './customPosts/CustomSinglePostPreview';
import ReactGA from "react-ga";

// const accessToken = 'EAAGDF6WFdgwBAKZC9NFoP1yxE29PdJAzprvyNFJN2zOihdAAaxr5m7OLVBnLFfKxbqIlAf0cZCX8weJeC5mN7rElOS5H5u0kXKrAOOOzwcA0yoB27aDX0TtwPZCKXJHOl7CDSMhtHUOK7zv2GXtmlEernV1gKFbjZBsfnLDB2QijowH8d185';
// const accountId = '269773933645768';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;
const facebook_campaigns_status = process.env.REACT_APP_FACEBOOK_CAMPAIGNS_STATUS;

class FacebookSponsoredMessage extends Component {
    state = {
        isEditing: false,
        spinnerActive: false,
        errorMessage: '',
        listOfErrors: [],
        user: {},
        data: {},
        adAccounts: [],
        selectedAdAccount: '',
        selectedAdAccountId: '',
        selectedAdAccountIsBusiness: '',
        user_facebook_pages: [],
        selectedSourceFbPages: [],
        activeStep: '1',
        selectedPage: '',
        selectedPageId: '',
        // selectedPageToken: '',
        campaignId: '',
        campaignName: '',
        campaignBudgetType: '',
        budgetAmount: '',
        bidControl: 30,
        startDate: '',
        endDate: '',
        characterCount: 0,
        adSetId: '',
        get_title_from_url: true,
        loading_title: '',
        messageContent: '',
        link: '',
        previewTitle: '',
        imageFromLink: '',
        adCreativeId: '',
        adId: '',
        showAdvancedOptions: false,
        deliverySchedule: 'continuously',
        fbAdsManagementPermission: false,
        native: false,
        specialAdCategory: false,
        showErrorNotification: false,
        imageHash: '',
        imageHashUrl: '',
        imageName: '',
        loaded: 0,
        selectedFile: '',
        selectedFileData: '',
        pageLoader: false
    };
    closeEmojiMart = (e) => {
        let clickedElement = e.target;
        if (document.querySelector('.emoji-mart')) {
            let emojiMart = document.querySelector('.emoji-mart');
            let emojiToggle = document.querySelector('.fa-smile');
            if (!emojiMart.contains(clickedElement)) {
                if (clickedElement !== emojiToggle) {
                    emojiMart.style.display = 'none'
                }
            }
        }

    };


    async componentDidMount() {
        this.setState({pageLoader: true})
        //ReactGA.pageview(window.location.pathname + window.location.search);
        document.addEventListener("click", this.closeEmojiMart);
        // const user_id = await getCurrentUserId();
        // const user = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        const user = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        await this.setState({
            user: user.data.data,
        })
        const accessToken = this.state.user.user_fb_extended_token;

        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        if (postDataPassed) {
            await this.setState({
                link: postDataPassed.short_url,
            })
            await this.updateValue('link', postDataPassed.short_url);
            await this.getLinkData()
        }

        try {
            if (user.data.data.user_fb_id) {
                this.checkAdsManagementPermission(user.data.data.user_fb_id, accessToken);
            }
            const today = new Date();
            const inThreeDays = new Date(today);
            inThreeDays.setDate(inThreeDays.getDate() + 3);
            /* Get facebook accounts, returns each account Id and Name */
            try{
                const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + accessToken + '&fields=name,owner,account_id,business_name');

                if (fbAdAccounts) {
                    await this.setState({
                        adAccounts: fbAdAccounts.data.data
                    })
                }
                let accountsMap = this.state.adAccounts ? this.state.adAccounts.map(async account => {
                    let result = await this.getAccountWithImage(account)
                    // this.state.adAccounts.find(item=> item.account_id === result.account_id)
                    let index = this.state.adAccounts.findIndex((item) => {
                        return item.account_id === result.account_id
                    })

                    let adAccounts = this.state.adAccounts;
                    adAccounts[index] = result;
                    await this.setState({
                        adAccounts: adAccounts
                    })
                }) : '';
                if (this.state.adAccounts && this.state.adAccounts.length === 1) {
                    await this.setState({
                        selectedAdAccount: this.state.adAccounts[0].name,
                        selectedAdAccountId: this.state.adAccounts[0].name.slice(4)
                    })
                }
                // console.log('fbAccounts show them to me: ', fbAccounts)
                let facebookPages = [];
                // console.log('if result: ', this.props.user_facebook_pages, this.state.user_facebook_pages)
                if (this.props.user_facebook_pages && (this.props.user_facebook_pages !== this.state.user_facebook_pages)) {
                    facebookPages = await this.props.user_facebook_pages.filter(page => (page.feed_id ? page.feed_id.toString() : '0' === this.props.selectedSource.toString()));
                    await this.setState({
                        selectedSourceFbPages: facebookPages,
                        selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
                    })
                } else if (this.props.facebook_pages_shared && (this.props.facebook_pages_shared !== this.state.selectedSourceFbPagesShared)) {
                    await this.setState({
                        selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
                    })
                }
                await this.setState({
                    user: this.state.user,
                    user_facebook_pages: this.props.user_facebook_pages,
                    startDate: today,
                    endDate: inThreeDays,
                    selectedAdAccountId: this.state.user.add_account_id,
                    pageLoader: false
                });
                if (this.state.user) {
                    setCurrentUserName(this.state.user.name);
                }
            }catch(e){
                const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + accessToken + '&fields=name,account_id');

                if (fbAdAccounts) {
                    await this.setState({
                        adAccounts: fbAdAccounts.data.data
                    })
                }
                let accountsMap = this.state.adAccounts ? this.state.adAccounts.map(async account => {
                    let result = await this.getAccountWithImage(account)
                    // this.state.adAccounts.find(item=> item.account_id === result.account_id)
                    let index = this.state.adAccounts.findIndex((item) => {
                        return item.account_id === result.account_id
                    })

                    let adAccounts = this.state.adAccounts;
                    adAccounts[index] = result;
                    await this.setState({
                        adAccounts: adAccounts
                    })
                }) : '';
                if (this.state.adAccounts && this.state.adAccounts.length === 1) {
                    await this.setState({
                        selectedAdAccount: this.state.adAccounts[0].name,
                        selectedAdAccountId: this.state.adAccounts[0].name.slice(4)
                    })
                }
                // console.log('fbAccounts show them to me: ', fbAccounts)
                let facebookPages = [];
                // console.log('if result: ', this.props.user_facebook_pages, this.state.user_facebook_pages)
                if (this.props.user_facebook_pages && (this.props.user_facebook_pages !== this.state.user_facebook_pages)) {
                    facebookPages = await this.props.user_facebook_pages.filter(page => (page.feed_id ? page.feed_id.toString() : '0' === this.props.selectedSource.toString()));
                    await this.setState({
                        selectedSourceFbPages: facebookPages,
                        selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
                    })
                } else if (this.props.facebook_pages_shared && (this.props.facebook_pages_shared !== this.state.selectedSourceFbPagesShared)) {
                    await this.setState({
                        selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
                    })
                }
                await this.setState({
                    user: this.state.user,
                    user_facebook_pages: this.props.user_facebook_pages,
                    startDate: today,
                    endDate: inThreeDays,
                    selectedAdAccountId: this.state.user.add_account_id,
                    pageLoader: false
                });
                if (this.state.user) {
                    setCurrentUserName(this.state.user.name);
                }
            }

            // console.log('Fb Response: ', fbAdAccounts)

        } catch (ex) {
            if (ex.response && ex.response.data.error.error_user_msg){
                this.setState({
                    errorMessage: ex.response.data.error.error_user_msg,
                    listOfErrors: [ ex.response.data.error.error_user_msg],
                    pageLoader: false
                })
            }
        }
    }

    async componentDidUpdate() {
        let facebookPages = [];
        // console.log('if result: ', this.props.user_facebook_pages, this.state.user_facebook_pages)
        if (this.props.user_facebook_pages && (this.props.user_facebook_pages !== this.state.user_facebook_pages)) {
            facebookPages = await this.props.user_facebook_pages.filter(page => (page.feed_id ? page.feed_id.toString() : '0' === this.props.selectedSource.toString()));
            await this.setState({
                user_facebook_pages: this.props.user_facebook_pages,
                selectedSourceFbPages: facebookPages,
                selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
            })
        } else if (this.props.facebook_pages_shared && (this.props.facebook_pages_shared !== this.state.selectedSourceFbPagesShared)) {
            await this.setState({
                selectedSourceFbPagesShared: this.props.facebook_pages_shared || []
            })
        }
        // if ( this.state.errorMessage ){
        //     this.setState({
        //         errorMessage: ''
        //     })
        // }
    }

    selectPage = (page) => {
        this.setState({
            selectedPage: page.fb_page || page.page,
            selectedPageId: page.fb_page_id || page.page_id,
            // selectedPageToken: page.page_access_token
        })
    }

    selectAdAccount = async (account) => {
        await this.setState({
            selectedAdAccount: account.name,
            selectedAdAccountId: account.id,
            selectedAdAccountIsBusiness: account.business_name !== "" ? true : false
        })
        const result = await http.post('api/sponsored_facebook/user/' + getCurrentUserId() + '/adaccounts', {add_account_id: account.id}, {headers: {authorization: getJwt()}});
        if (result) {
            const user = await http.get('api/user/' + getCurrentUserId(), {headers: {authorization: getJwt()}});
            const data = await user.data.data;
            await this.setState({
                user: {
                    ...this.state.user,
                    ...data
                }
            })
        }
    }


    setCampaignName = (event) => {
        this.setState({
            campaignName: event.target.value
        })
    }

    selectCampaignBudget = (budgetType) => {
        this.setState({
            campaignBudgetType: budgetType
        })
    }

    handleBidChange = (event) => {
        this.setState({
            bidControl: event.target.value
        })
    }

    nextClicked = () => {
        this.checkErrors();
        this.createCampaign();
        // this.setState({
        //     activeStep: '2'
        // })
    }

    previousClicked = () => {
        this.setState({
            activeStep: '1'
        })
    }

    handleBudgetAmountChange = (event) => {
        this.setState({
            budgetAmount: event.target.value
        })
    }

    handleInfoCircle = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot", e.target.slot);
        if (e.target.slot) {
            const targetFade = '.forbidden > #' + e.target.slot;

            $(targetFade).fadeToggle();
        }
    };

    handleClosePanel = () => {
        $('#forbidden > .team-user-panel').fadeToggle()
    };

    nextButtonDisabled = () => {
        if ((this.state.activeStep === '1') && this.state.selectedPage && this.state.campaignName && this.state.campaignBudgetType
            && this.state.budgetAmount && this.state.bidControl && this.state.startDate && this.state.endDate && !this.state.specialAdCategory) {
            return (false)
        } else {
            return (true)
        }

    }

    createCampaignButtonDisabled = () => {
        if ((this.state.activeStep === '2') && this.state.messageContent && this.state.selectedPageId && this.state.link && this.state.previewTitle
            && this.state.bidControl && this.state.imageHashUrl && this.state.imageHash) {
            return (false)
        } else {
            return (true)
        }
    }

    fileSelectedUploadHandler = (selectedFile) => {
        const reader = new FileReader();

        reader.addEventListener(
            'load',
            () => {
                this.setState({
                    selectedFileData: reader.result.split(',')[1]
                });
                this.fileUploadHandler()
            },
            false
        );
        reader.readAsDataURL(selectedFile.target.files[0]);
        this.setState({selectedFile: selectedFile.target.files[0]});
        // console.log('fileSelectedUploadHandler func: ', this.state.selectedFileData, this.state.selectedFile)
    };

    fileUploadHandler = async () => {
        const accessToken = this.state.user.user_fb_extended_token;
        const accountId = this.state.user.add_account_id;
        // const upload_URL = "https://api.emitto.io/api/files/"+getCurrentUserId();
        if (this.state.selectedFile) {
            let formData = {
                file: this.state.selectedFileData,
                category: "profile_photo",
                name: this.state.selectedFile.name,
                size: this.state.selectedFile.size,
                type: this.state.selectedFile.type
            };
            try {
                this.setState({fileUploadActive: true})
                http.post(facebook_app_marketing_url + accountId + '/adimages',
                    {
                        "special_ad_categories": "NONE",
                        "bytes": this.state.selectedFileData,
                        "access_token": accessToken
                    },
                    {headers: {authorization: getJwt()}},
                    {
                        onUploadProgress: progressEvent => {
                            this.setState({loaded: Math.round(progressEvent.loaded / progressEvent.total * 100)});
                        }
                    }
                ).then(res => {
                    toastr.success("Image is successfully uploaded!");
                    //setTimeout(() => {
                    this.setState({
                        imageHash: res.data.images.bytes.hash,
                        imageHashUrl: res.data.images.bytes.url,
                        imageName: this.state.selectedFile.name,
                        loaded: 0,
                        selectedFile: null,
                        selectedFileData: null
                    });
                    //}, 1000);
                    this.setState({fileUploadActive: false})
                    // console.log('Ovo je res za fileUploadHandler: ', this.state.imageHash, this.state.imageHashUrl )
                });
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }

        }
    };

    createCampaign = async () => {
        const accessToken = this.state.user.user_fb_extended_token;
        const accountId = this.state.user.add_account_id;
        try {
            this.setState({
                spinnerActive: true
            })
            let campaignName = this.state.campaignName + ' campaign';
            const result = await axios.post(facebook_app_marketing_url + accountId + '/campaigns', {
                "special_ad_categories": "NONE",
                "name": campaignName,
                "objective": "MESSAGES",
                "status": facebook_campaigns_status,
                "access_token": accessToken
            });

            //console.log('Ovo je rezultat kreiranja kampanje: ', result)
            if (result) {
                await this.setState({
                    spinnerActive: false,
                    campaignId: result.data.id
                })
                if (this.state.campaignBudgetType === 'lifetime') {
                    try {
                        let adSetName = this.state.campaignName + ' ad set';
                        let bidControl = await parseInt(this.state.bidControl) * 100;
                        let lifetimeBudget = await parseInt(this.state.budgetAmount) * 100;
                        const result2 = await axios.post(facebook_app_marketing_url + accountId + '/adsets', {
                            "special_ad_categories": "NONE",
                            "name": adSetName,
                            "optimization_goal": "IMPRESSIONS",
                            "billing_event": "IMPRESSIONS",
                            "bid_amount": bidControl || '',
                            "lifetime_budget": lifetimeBudget,
                            "campaign_id": this.state.campaignId,
                            "start_time": this.state.startDate,
                            "end_time": this.state.endDate,
                            "targeting": {
                                "publisher_platforms": ["messenger"],
                                "messenger_positions": ["sponsored_messages"],
                                "device_platforms": ["mobile", "desktop"]
                            },
                            "status": facebook_campaigns_status,
                            "promoted_object": {
                                "page_id": this.state.selectedPageId
                            },
                            "access_token": accessToken
                        });
                        if (result2) {
                            await this.setState({
                                spinnerActive: false,
                                adSetId: result2.data.id,
                                activeStep: '2',
                                errorMessage: ''
                            })
                        }
                        //console.log('Ad set Result: ', result2);
                    } catch (ex) {
                        if (ex.response && ex.response.data.error.error_user_msg){
                            this.setState({
                                errorMessage: ex.response.data.error.error_user_msg,
                                listOfErrors: [...this.state.listOfErrors, ex.response.data.error.error_user_msg]
                            })
                        }
                    }
                }
                if (this.state.campaignBudgetType === 'daily') {
                    try {
                        let adSetName = this.state.campaignName + ' ad set';
                        let bidControl = await parseInt(this.state.bidControl) * 100;
                        let dailyBudget = await parseInt(this.state.budgetAmount) * 100;
                        if (this.state.deliverySchedule === 'continuously') {
                            const result3 = await axios.post(facebook_app_marketing_url + accountId + '/adsets', {
                                "special_ad_categories": "NONE",
                                "name": adSetName,
                                "optimization_goal": "IMPRESSIONS",
                                "billing_event": "IMPRESSIONS",
                                "bid_amount": bidControl || '',
                                "daily_budget": dailyBudget,
                                "campaign_id": this.state.campaignId,
                                "targeting": {
                                    "publisher_platforms": ["messenger"],
                                    "messenger_positions": ["sponsored_messages"],
                                    "device_platforms": ["mobile", "desktop"]
                                },
                                "status": facebook_campaigns_status,
                                "promoted_object": {
                                    "page_id": this.state.selectedPageId
                                },
                                "access_token": accessToken
                            });
                            if (result3) {
                                await this.setState({
                                    spinnerActive: false,
                                    adSetId: result3.data.id,
                                    activeStep: '2',
                                    errorMessage: ''
                                })
                            }
                            //console.log('Ad set Result: ', result3);
                        } else if (this.state.deliverySchedule === 'daterange') {
                            const result3 = await axios.post(facebook_app_marketing_url + accountId + '/adsets', {
                                "special_ad_categories": "NONE",
                                "name": adSetName,
                                "optimization_goal": "IMPRESSIONS",
                                "billing_event": "IMPRESSIONS",
                                "bid_amount": bidControl || '',
                                "daily_budget": dailyBudget,
                                "campaign_id": this.state.campaignId,
                                "start_time": this.state.startDate,
                                "end_time": this.state.endDate,
                                "targeting": {
                                    "publisher_platforms": ["messenger"],
                                    "messenger_positions": ["sponsored_messages"],
                                    "device_platforms": ["mobile", "desktop"]
                                },
                                "status": facebook_campaigns_status,
                                "promoted_object": {
                                    "page_id": this.state.selectedPageId
                                },
                                "access_token": accessToken
                            });
                            if (result3) {
                                await this.setState({
                                    spinnerActive: false,
                                    adSetId: result3.data.id,
                                    activeStep: '2',
                                    errorMessage: ''
                                })
                            }
                            //console.log('Ad set Result: ', result3);
                        }

                    } catch (ex) {
                        if (ex.response && ex.response.data.error.error_user_msg){
                            this.setState({
                                errorMessage: ex.response.data.error.error_user_msg,
                                listOfErrors: [ ex.response.data.error.error_user_msg]
                            })
                        }
                    }
                }
            }


        } catch (ex) {
            // alert("aaaaaaaa");
            if (ex.response && ex.response.data.error.error_user_msg){
                this.setState({
                    errorMessage: ex.response.data.error.error_user_msg,
                    listOfErrors: [ ex.response.data.error.error_user_msg]
                })
            }
        }
        this.setState({
            spinnerActive: false
        })
    }

    adCreative = async () => {
        const accessToken = this.state.user.user_fb_extended_token;
        const accountId = this.state.user.add_account_id;
        try {
            this.setState({
                spinnerActive: true
            })
            let campaignName = this.state.campaignName + ' campaign';
            const result = await axios.post(facebook_app_marketing_url + accountId + '/adcreatives', {
                "special_ad_categories": "NONE",
                "object_id": this.state.selectedPageId,
                "object_type": "SHARE",
                "messenger_sponsored_message":
                    {
                        "message": {
                            "attachment":
                                {
                                    "type": "template",
                                    "payload": {
                                        "template_type": "generic",
                                        "elements": [{
                                            "title": this.state.previewTitle,
                                            "image_hash": this.state.imageHash,
                                            // "image_url": this.state.imageFromLink,
                                            "buttons": [{
                                                "type": "web_url",
                                                "title": "READ",
                                                "url": this.state.link
                                            }]
                                        }]
                                    }
                                },
                            "text": this.state.messageContent
                        }
                    },
                "access_token": accessToken
            });

            //console.log('Ovo je rezultat kreiranja Ad Creatives: ', result)
            if (result) {
                await this.setState({
                    adCrativeId: result.data.id
                })
                try {
                    let adName = this.state.campaignName + ' ad name';
                    const result2 = await axios.post(facebook_app_marketing_url + accountId + '/ads', {
                        "special_ad_categories": "NONE",
                        "name": adName,
                        "adset_id": this.state.adSetId,
                        "creative": {
                            "creative_id": this.state.adCrativeId
                        },
                        "status": facebook_campaigns_status,
                        "access_token": accessToken
                    });
                    if (result2) {
                        await this.setState({
                            adId: result2.data.id,
                        })
                    }
                    toastr.success("You have successfully created " + this.state.campaignName + " campaign");
                    this.props.history.push('/new')
                    // console.log('Ad Result: ', result2);
                } catch (ex) {
                    if (ex.response && ex.response.data.error.error_user_msg){
                        await this.setState({
                            errorMessage: ex.response.data.error.error_user_msg,
                            listOfErrors: [ex.response.data.error.error_user_msg]
                        })
                    }
                }
            }
        } catch (ex) {
            // alert("aaaaaaaa");
            if (ex.response && ex.response.data.error.error_user_msg){
                await this.setState({
                    errorMessage: ex.response.data.error.error_user_msg,
                    listOfErrors: [ex.response.data.error.error_user_msg]
                })
            }
        }
        this.setState({
            spinnerActive: false
        })
    }

    handleMessage = (message) => {
        this.setState({characterCount: message.length, messageContent: message});

    };

    toggleEmoji = async () => {
        let x = document.querySelector('.emoji-mart');

        if (x.style.display === "none") {
            document.querySelector('#post-message-text').focus();
            x.style.display = "block";
            await this.setState({native: true})

        } else {
            x.style.display = "none";
            await this.setState({native: true})

        }
    };

    handleEmoji = (e) => {
        //console.log('clicked:', e.native);

        document.querySelector('#post-message-text').value += e.native;
        let messageText = document.querySelector('#post-message-text').value;
        this.setState({characterCount: messageText.length, messageContent: messageText})
        document.querySelector('#post-message-text').focus();

    };

    isValidUrl = (userInput) => {

        //console.log('isValidUrl activated');
        let res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        if (res == null) {
            return false;
        } else {
            return true;
        }
    }

    getLinkData = async (index = null, value = null, link = null) => {
        // console.log('value:', value);
        // console.log('link: ', link);
        let validLink = '';
        if (this.state.showSingle === false) {
            if (link !== null) {
                validLink = this.isValidUrl(value);
            }
        } else {
            validLink = this.isValidUrl(this.state.link)
        }

        // console.log('valid link:', validLink);

        if (validLink === true) {
            this.setState({
                loading_title: true
            });

            const API_META = "https://api.microlink.io/?url=";

            let URL_META = this.state.link;
            let n = URL_META.startsWith('http');
            // console.log('value:', URL_META);
            // console.log('n:', n);
            if (n === false) {
                URL_META = 'http://' + URL_META
                this.setState({link: URL_META});
            }

            try {
                const result = await axios.get(API_META + URL_META);
                // console.log('getLinkData result: ', result)
                if (result.status !== "ERROR") {
                    await this.setState({
                        imageFromLink: result.data.data.image ? result.data.data.image.url : "https://vignette.wikia.nocookie.net/mixels/images/f/f4/No-image-found.jpg/revision/latest?cb=20150916222215"
                    });

                    await this.updateValue('previewTitle', result.data.data.title || "");
                    await this.setState({
                        loading_title: false,
                        get_title_from_url: true
                    });
                } else {
                    this.setState({
                        imageFromLink: "https://onaliternote.files.wordpress.com/2016/11/wp-1480230666843.jpg",
                        loading_title: false
                    });
                }
            } catch (ex) {
                // console.log("catch (ex) ", ex);
                this.setState({
                    loading_title: false,
                    get_title_from_url: false,
                    imageFromLink: '',
                    previewTitle: '',
                    loading_title_multiple_custom: [
                        {
                            loading_title: false
                        },
                        {
                            loading_title: false
                        }
                    ]
                });
            }
        }
    }

    updateValue = (fieldName, value, field_id = null) => {
        this.setState({
            [fieldName]: value
        })
    };

    handleGetTitleFromUrl = (e) => {
        const id = e.target.id;
        const name = e.target.name;
        if (this.state.get_title_from_url) {
            this.setState({
                title: ""
            });
        }
        this.setState({
            get_title_from_url: !this.state.get_title_from_url
        });
    };

    toggleShowAdvanced = () => {
        this.setState({
            showAdvancedOptions: !this.state.showAdvancedOptions
        })
    }

    selectDeliverySchedule = (value) => {
        this.setState({
            deliverySchedule: value
        })
    }

    getAccountWithImage = async (account) => {
        let name = account.name.replace(/\s/g, '')
        let url = !account.business_name ? "https://graph.facebook.com/" + account.owner + "/picture" : "https://graph.facebook.com/" + name + "/picture";
        // let checkUrl = await this.apiResult(url)
        // if (checkUrl) {
        let accountWithImage = {
            ...account,
            image: url
        }
        return accountWithImage;
        // } else {
        //     let accountWithoutImage = {
        //         ...account,
        //         image: account.business_name ? 'businessAccount' : 'privateAccount'
        //     }
        //     return accountWithoutImage
        // }
    }

    apiResult = async (url) => {
        try {
            let result = await axios.get(url);
            return true
        } catch {
            return false
        }
    }

    checkErrors = async () => {
        let listOfErrors = [];
        if (this.state.activeStep === '1') {
            if (!this.state.selectedPage) {
                listOfErrors.push('Select Facebook Page ')
            }
            ;
            if (!this.state.campaignName) {
                listOfErrors.push('Enter Campaign Name ')
            }
            ;
            if (!this.state.campaignBudgetType) {
                listOfErrors.push('Select Campaign Budget Type ')
            }
            ;
            if (!this.state.budgetAmount) {
                listOfErrors.push('Enter Budget Amount ')
            }
            ;
            if (!this.state.bidControl) {
                listOfErrors.push('Enter Max Bid Amount ')
            }
            ;
            if (!this.state.startDate) {
                listOfErrors.push('Select Start Date ')
            }
            ;
            if (!this.state.endDate) {
                listOfErrors.push('Select End Date ')
            }
            ;
        } else if (this.state.activeStep === '2') {
            if (!this.state.selectedPageId) {
                listOfErrors.push('Select Facebook Page ')
            }
            ;
            if (!this.state.messageContent) {
                listOfErrors.push('Enter Greeting Message ')
            }
            ;
            if (!this.state.link) {
                listOfErrors.push('Enter Post Link ')
            }
            ;
            if (!this.state.previewTitle) {
                listOfErrors.push('Enter Preview Title ( if not fetched from link )')
            }
            ;
            if (!this.state.imageHash) {
                listOfErrors.push('Upload Image ')
            }
            ;
        }

        await this.setState({
            errorMessage: listOfErrors.length > 0 ? 'You need to fix this errors: ' : '',
            listOfErrors
        })
        if (this.state.errorMessage !== '') {
            toastr.error('Please check errors!')
        }
    }

    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token) => {
        if (user_fb_id && user_fb_extended_token) {
            try {
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token);
                const fbAdsManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'ads_management');
                /* changed to 'ads_management' from from 'pages_manage_ads' */

                if (fbAdsManagementPermission) {
                    await this.setState({
                        fbAdsManagementPermission: (fbAdsManagementPermission.status === 'granted') ? true : false
                    })
                }
                // console.log('Permisije, permisije: ', fbAdsManagementPermission, this.state.fbAdsManagementPermission)
            } catch (ex) {
                if (ex.response && ex.response.data.error.error_user_msg){
                    this.setState({
                        errorMessage: ex.response.data.error.error_user_msg,
                        listOfErrors: [ ex.response.data.error.error_user_msg]
                    })
                }
            }
        }
    }

    responseFacebook = async (response) => {
        // const user_id = await getCurrentUserId();
        // const resp = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        const resp = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        const user = await resp.data.data;
        await this.setState({
            user: user
        })
        try {
            // console.log('Facebook user id: ', response)
            await this.checkAdsManagementPermission(response.id, response.accessToken)
            /* Get facebook accounts, returns each account Id and Name */
            if (this.state.fbAdsManagementPermission) {
                try{
                    const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + this.state.user.user_fb_extended_token + '&fields=name,owner,account_id,business_name');

                    if (fbAdAccounts) {
                        await this.setState({
                            adAccounts: fbAdAccounts.data.data
                        })
                        if (!this.state.user.selectedAdAccount) {

                        }
                        this.selectAdAccount(fbAdAccounts.data.data[0])
                    }
                }catch{
                    const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + this.state.user.user_fb_extended_token + '&fields=name,account_id');

                    if (fbAdAccounts) {
                        await this.setState({
                            adAccounts: fbAdAccounts.data.data
                        })
                        if (!this.state.user.selectedAdAccount) {

                        }
                        this.selectAdAccount(fbAdAccounts.data.data[0])
                    }
                }
            }
            let accountsMap = this.state.adAccounts ? this.state.adAccounts.map(async account => {
                let result = await this.getAccountWithImage(account)
                // this.state.adAccounts.find(item=> item.account_id === result.account_id)
                let index = this.state.adAccounts.findIndex((item) => {
                    return item.account_id === result.account_id
                })

                let adAccounts = this.state.adAccounts;
                adAccounts[index] = result;
                await this.setState({
                    adAccounts: adAccounts
                })
            }) : '';
        } catch (ex) {
            if (ex.response && ex.response.data.error.error_user_msg){
                this.setState({
                    errorMessage: ex.response.data.error.error_user_msg,
                    listOfErrors: [ ex.response.data.error.error_user_msg]
                })
            }
        }
    }

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    render() {
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        return <React.Fragment>
            <h1 className='main-title'>Facebook Sponsored Message</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                className="fas fa-chevron-left"></i> New Campaign</p>
            <div className="">
                {this.state.pageLoader ?
                    <div className='full-screen-loader'>
                        <img src="/img/chart-loader.svg" alt="Loading..." alt=""/>
                    </div>
                    :
                    this.state.adAccounts.length === 0 ?
                    <div className="campaign-performance-no-account-id-container">
                        <h3>In order to see Facebook Campaigns, You need at least one Facebook ad account. Please go to
                            <a onClick={() => this.props.history.push('/channels')}> Channels</a> , activate Facebook
                            Messenger and connect Facebook page to Workspace. <br/>
                            If you doesn't have an ad account for your Facebook page, please create ad account and try
                            again.</h3>
                    </div>
                    :
                    this.state.fbAdsManagementPermission ?
                        <div className="fb-message-wrapper">

                            <div className="step-selector">
                                <h3
                                    style={{
                                        fontSize: '15px',
                                        opacity: this.state.activeStep.toString() === '1' ? 1 : 0.5
                                    }}>
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            padding: this.state.activeStep.toString() === '1' ? '7px 15px' : '7px 10px'
                                        }}>
                                        {this.state.activeStep.toString() === '1' ? 1 : <i className="fa fa-check"/>}
                                    </span>
                                    Campaign Setup
                                </h3>

                                <h3
                                    style={{
                                        fontSize: '15px',
                                        opacity: this.state.activeStep.toString() === '2' ? 1 : 0.5
                                    }}><span>2</span>Ad Creative</h3>
                            </div>
                            {this.state.activeStep.toString() === '1' ?
                                <div>
                                    <div className="flex-row-wrapper">
                                        <p className="full-row-label">Select Ad Account</p>
                                        {this.state.selectedSourceFbPages && (this.state.adAccounts.length > 0) ? this.state.adAccounts.map(account => {
                                            return <div
                                                className={this.state.selectedAdAccountId === account.id ? "fb-page-container active" : "fb-page-container"}
                                                onClick={() => this.selectAdAccount(account)}
                                            >
                                                <div className="fb-page-image-container">
                                                    {account.image === 'businessAccount' ?
                                                        <i className="fas fa-user-tie"/>
                                                        :
                                                        account.image === 'privateAccount' ?
                                                            <i className="fas fa-user"/>
                                                            :
                                                            <img src={account.image} onError={this.addDefaultSrc}/>
                                                    }
                                                </div>
                                                <div>
                                                    <p className="margin-vertical-5">{account.name}</p>
                                                    <p className="margin-vertical-5">Account id: {account.id}</p>
                                                </div>
                                            </div>
                                        }) : <h2>There are no Ad Accounts</h2>}

                                    </div>
                                    {this.state.user.add_account_id ?
                                        <div>
                                            <div className="flex-row-wrapper">
                                                <p className="full-row-label">Select Page</p>
                                                {this.state.selectedSourceFbPages ? this.state.selectedSourceFbPages.map(page => {
                                                    return <div
                                                        className={this.state.selectedPage === page.fb_page ? "fb-page-container active" : "fb-page-container"}
                                                        onClick={() => this.selectPage(page)}
                                                    >
                                                        <div className="fb-page-image-container">
                                                            {
                                                                <img
                                                                    src={"https://graph.facebook.com/" + page.fb_page_id + "/picture"}
                                                                    onError={this.addDefaultSrc}/>}
                                                        </div>
                                                        <p>{page.fb_page}</p>
                                                    </div>
                                                }) : ''}
                                                {this.state.selectedSourceFbPagesShared ? this.state.selectedSourceFbPagesShared.map(page => {
                                                    return <div
                                                        className={this.state.selectedPage === page.page ? "fb-page-container active" : "fb-page-container"}
                                                        onClick={() => this.selectPage(page)}
                                                    >
                                                        <div className="fb-page-image-container">
                                                            {<img
                                                                src={"https://graph.facebook.com/" + page.id + "/picture"}
                                                                onError={this.addDefaultSrc}/>}
                                                        </div>
                                                        <p>{page.page}</p>
                                                    </div>
                                                }) : !this.state.selectedSourceFbPages ?
                                                    <h2>There are no Fb Pages</h2> : ''}
                                            </div>
                                            <div className="flex-row-wrapper margin-bottom-10">
                                                <p className="full-row-label">Campaign Name</p>
                                                <input
                                                    className={this.state.campaignName !== '' ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                    type="text"
                                                    style={{width: '49%'}}
                                                    value={this.state.campaignName}
                                                    placeholder={'Campaign Name'}
                                                    onChange={this.setCampaignName}
                                                />
                                            </div>

                                            <div className="flex-row-wrapper margin-bottom-10">
                                                <p className="full-row-label">Campaign Budget</p>
                                                <div
                                                    className={this.state.campaignBudgetType === 'lifetime' ? "fb-budget-container active" : "fb-budget-container"}
                                                    onClick={() => this.selectCampaignBudget('lifetime')}
                                                >
                                                    <h3>Lifetime Budget</h3>
                                                    <p>You will never spend more than the amount you previously set.</p>
                                                </div>
                                                <div
                                                    className={this.state.campaignBudgetType === 'daily' ? "fb-budget-container active" : "fb-budget-container"}
                                                    onClick={() => this.selectCampaignBudget('daily')}
                                                >
                                                    <h3>Daily Budget</h3>
                                                    <p>You may spend more some days, and less the other, but will
                                                        maintain
                                                        an average daily budget. </p>
                                                </div>
                                            </div>
                                            {this.state.campaignBudgetType === 'lifetime' ?
                                                <div className="flex-row-wrapper margin-bottom-10">
                                                    <div className="flex-half-wrapper">
                                                        <div className="flex-quarter-wrapper">
                                                            <p className="full-row-label">Budget Amount ($) <Popover
                                                                interactionKind={PopoverInteractionKind.HOVER}
                                                               
                                                                position={Position.RIGHT}
                                                            >
                                                                    <span
                                                                        intent={Intent.PRIMARY}
                                                                        style={{color: 'lightgrey'}}
                                                                        className="fas fa-question-circle"
                                                                        slot={'bidControl'}
                                                                    ></span>
                                                                <div className='padding-10'>
                                                                    <h5>Budget Amount</h5>
                                                                    <p>Set the maximum daily or lifetime amount that you
                                                                        want to spend on this campaign.</p>
                                                                </div>
                                                            </Popover>
                                                            </p>
                                                            <input
                                                                className={this.state.budgetAmount !== '' ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                                type="text"
                                                                value={this.state.budgetAmount}
                                                                placeholder={'Input amount'}
                                                                onChange={this.handleBudgetAmountChange}
                                                            />
                                                        </div>
                                                        <div className="flex-quarter-wrapper">
                                                            <p className="full-row-label">Bid Control ($)
                                                                <Popover
                                                                interactionKind={PopoverInteractionKind.HOVER}
                                                               
                                                                position={Position.RIGHT}
                                                            >
                                                                    <span
                                                                        intent={Intent.PRIMARY}
                                                                        style={{color: 'lightgrey'}}
                                                                        className="fas fa-question-circle"
                                                                        slot={'bidControl'}
                                                                    ></span>
                                                                <div className='padding-10'>
                                                                    <h5>Bid Control</h5>
                                                                    <p>We recommend you to bid with the default country
                                                                        bid amount for Sponsored Messages ($30). You can
                                                                        find the minimum and maximum bid amounts for
                                                                        your
                                                                        target audience
                                                                        <a href="https://developers.facebook.com/docs/messenger-platform/discovery/sponsored-messages/country-bids#default_country_bid"
                                                                           target="_blank"> here</a>.
                                                                    </p>
                                                                </div>
                                                            </Popover>
                                                            </p>
                                                            <input
                                                                className={this.state.bidControl !== '' ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                                type="text"
                                                                value={this.state.bidControl}
                                                                placeholder={'Auto optimized'}
                                                                onChange={this.handleBidChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex-half-wrapper">
                                                        <div className="flex-quarter-wrapper">
                                                            <p className="full-row-label">Start Date</p>
                                                            <div className="fb-date-container active">
                                                                <DatePicker
                                                                    selected={this.state.startDate}
                                                                    onChange={date => this.setState({startDate: date})}
                                                                    minDate={new Date()}
                                                                    dateFormat="MMMM d, yyyy"
                                                                />
                                                                <span className="fa fa-calendar"/>
                                                            </div>
                                                        </div>
                                                        <div className="flex-quarter-wrapper">
                                                            <p className="full-row-label">End Date </p>
                                                            <div className="fb-date-container active">
                                                                <DatePicker
                                                                    selected={this.state.endDate}
                                                                    onChange={date => this.setState({endDate: date})}
                                                                    minDate={new Date()}
                                                                    dateFormat="MMMM d, yyyy"
                                                                />
                                                                <span className="fa fa-calendar"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                this.state.campaignBudgetType === 'daily' ?
                                                    <div className="flex-row-wrapper">
                                                        <div className="flex-half-wrapper margin-bottom-10">
                                                            <div className="flex-quarter-wrapper">
                                                                <p className="full-row-label">Daily Budget ($)
                                                                    <Popover
                                                                    interactionKind={PopoverInteractionKind.HOVER}
                                                                   
                                                                    position={Position.RIGHT}
                                                                >
                                                                        <span
                                                                            intent={Intent.PRIMARY}
                                                                            style={{color: 'lightgrey'}}
                                                                            className="fas fa-question-circle"
                                                                            slot={'bidControl'}
                                                                        ></span>
                                                                    <div className='padding-10'>
                                                                        <h5>Daily Budget</h5>
                                                                        <p>Your ad set budget is the daily or lifetime
                                                                            amount
                                                                            that you want to spend onthisad set.
                                                                            A daily budget is the average that you'll
                                                                            spend every day.
                                                                            A lifetime budget is the maximum that you'll
                                                                            spend
                                                                            during the lifetime of your ad set.</p>
                                                                    </div>
                                                                </Popover>
                                                                </p>
                                                                <div
                                                                    className={this.state.budgetAmount ? "fb-campaign-name-container active" : "fb-campaign-name-container"}>
                                                                    <input
                                                                        className={this.state.budgetAmount ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                                        type="text"
                                                                        value={this.state.budgetAmount}
                                                                        placeholder={'Input amount'}
                                                                        onChange={this.handleBudgetAmountChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="flex-quarter-wrapper">
                                                                <p className="full-row-label">Bid Control ($)
                                                                    <Popover
                                                                    interactionKind={PopoverInteractionKind.HOVER}
                                                                   
                                                                    position={Position.RIGHT}
                                                                >
                                                                        <span
                                                                            intent={Intent.PRIMARY}
                                                                            style={{color: 'lightgrey'}}
                                                                            className="fas fa-question-circle"
                                                                            slot={'bidControl'}
                                                                        ></span>
                                                                    <div className='padding-10'>
                                                                        <h5>Bid Control</h5>
                                                                        <p>We recommend you to bid with the default
                                                                            country
                                                                            bid amount for Sponsored Messages ($30). You
                                                                            can
                                                                            find the minimum and maximum bid amounts for
                                                                            your
                                                                            target audience
                                                                            <a href="https://developers.facebook.com/docs/messenger-platform/discovery/sponsored-messages/country-bids#default_country_bid"
                                                                               target="_blank"> here</a>.
                                                                        </p>
                                                                    </div>
                                                                </Popover>
                                                                </p>
                                                                <input
                                                                    className={this.state.bidControl ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                                    type="text"
                                                                    value={this.state.bidControl}
                                                                    placeholder={'Auto optimized'}
                                                                    onChange={this.handleBidChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        {this.state.showAdvancedOptions ?
                                                            <div>
                                                                <div className="flex-row-wrapper">
                                                                    <p className="full-row-label">Delivery Schedule</p>
                                                                    <div
                                                                        className={this.state.deliverySchedule === 'continuously' ? "fb-budget-container active" : "fb-budget-container"}
                                                                        onClick={() => this.selectDeliverySchedule('continuously')}
                                                                    >
                                                                        <h3>Run Ads Continuously</h3>
                                                                        <p>Your ad will run continuously starting
                                                                            today.</p>
                                                                    </div>
                                                                    <div
                                                                        className={this.state.deliverySchedule === 'daterange' ? "fb-budget-container active" : "fb-budget-container"}
                                                                        onClick={() => this.selectDeliverySchedule('daterange')}
                                                                    >
                                                                        <h3>Set Start and End Date</h3>
                                                                        <p>Your ad will run within a date range you
                                                                            select.</p>
                                                                    </div>
                                                                </div>
                                                                {this.state.deliverySchedule === 'daterange' ?
                                                                    <div className="flex-row-wrapper flex-end">
                                                                        <div className="flex-half-wrapper">
                                                                            <div className="flex-quarter-wrapper">
                                                                                <p className="full-row-label">Start
                                                                                    Date </p>
                                                                                <div
                                                                                    className="fb-date-container active">
                                                                                    <DatePicker
                                                                                        selected={this.state.startDate}
                                                                                        onChange={date => this.setState({startDate: date})}
                                                                                        minDate={new Date()}
                                                                                        dateFormat="MMMM d, yyyy"
                                                                                    />
                                                                                    <span className="fa fa-calendar"/>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex-quarter-wrapper">
                                                                                <p className="full-row-label">End
                                                                                    Date</p>
                                                                                <div
                                                                                    className="fb-date-container active">
                                                                                    <DatePicker
                                                                                        selected={this.state.endDate}
                                                                                        onChange={date => this.setState({endDate: date})}
                                                                                        minDate={new Date()}
                                                                                        dateFormat="MMMM d, yyyy"
                                                                                    />
                                                                                    <span className="fa fa-calendar"/>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                            : ''
                                                        }
                                                        {this.state.showAdvancedOptions ?
                                                            <div className="show-advanced-options">
                                                                <p onClick={this.toggleShowAdvanced}>
                                                                    Hide Advanced Options <i
                                                                    className="fa fa-chevron-up"/>
                                                                </p>
                                                            </div>
                                                            :
                                                            <div className="show-advanced-options">
                                                                <p onClick={this.toggleShowAdvanced}>
                                                                    Show Advanced Options <i
                                                                    className="fa fa-chevron-down"/>
                                                                </p>
                                                            </div>
                                                        }
                                                    </div>
                                                    : ''
                                            }
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                                :
                                <div>
                                    <div className="flex-row-wrapper">
                                        <div className="section m-lg-b ad-creative-wrapper">
                                            <div className="section-container col-md-6 no-padding-top">
                                                <div className="form-group greeting-message">
                                                    <React.Fragment>
                                                        <EmojiTextArea
                                                            uniqueId='introduction'
                                                            onUpdate={this.handleMessage}
                                                            label={'Greeting Message'}
                                                            placeholder={'Your introduction message goes here'}
                                                            height={120}
                                                            maxCharacters={400}
                                                            infoCircleType={'question'}
                                                            infoCircleContent='The message you want to send goes here'
                                                            showMessagesNumber={false}
                                                        />
                                                        {/*<textarea*/}
                                                        {/*id='post-message-text'*/}
                                                        {/*maxLength='400'*/}
                                                        {/*placeholder="The message you want to send goes here"*/}
                                                        {/*onChange={(e) => {*/}
                                                        {/*this.handleMessage(e.target.value)*/}
                                                        {/*}}>*/}
                                                        {/*</textarea>*/}
                                                        {/*<div className="message-options">*/}
                                                        {/*<div className="emoji-selector-container">*/}
                                                        {/*<span onClick={this.toggleEmoji}*/}
                                                        {/*className='far fa-smile'></span>*/}
                                                        {/*<Picker*/}
                                                        {/*autoFocus={true}*/}
                                                        {/*native={this.state.native}*/}
                                                        {/*style={{display: 'none'}} onClick={(e) => {*/}
                                                        {/*this.handleEmoji(e)*/}
                                                        {/*}}/>*/}
                                                        {/*</div>*/}
                                                        {/*<p className='character-count'>Characters:<span> {this.state.characterCount}/400</span>*/}
                                                        {/*</p>*/}
                                                        {/*</div>*/}
                                                    </React.Fragment>
                                                </div>


                                                <div className="form-group fb-spons-message">
                                                    <span className="label">Post Link</span>
                                                    {this.state.get_title_from_url ?
                                                        <input
                                                            id='post-link'
                                                            placeholder="http://example.com/post"
                                                            className={this.state.link ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                            type="text"
                                                            value={this.state.link}
                                                            onBlur={this.getLinkData}
                                                            onChange={(e) => {
                                                                this.updateValue('link', e.target.value)
                                                            }}/>
                                                        :
                                                        <input
                                                            id='post-link'
                                                            placeholder="http://example.com/post"
                                                            type="text"
                                                            value={this.state.link}
                                                            className={this.state.link ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                            onChange={(e) => {
                                                                this.updateValue('link', e.target.value)
                                                            }}/>
                                                    }

                                                </div>
                                                <div className="form-group fb-spons-message">
                                                    <span className="label">Title <label className="right checkbox">
                                                        Fetch the title from the link
                                                        <input
                                                            id="single" name="single" type="checkbox"
                                                            checked={this.state.get_title_from_url}
                                                            onChange={this.handleGetTitleFromUrl}/>
                                                    <span className="checkmark"></span>
                                                        </label>
                                                    </span>
                                                    <input
                                                        id='post-title'
                                                        className={this.state.loading_title ? "input-loading" : this.state.previewTitle ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}
                                                        placeholder="You can use a fetched default, or change it to a custom title"
                                                        type="text"
                                                        value={this.state.previewTitle}
                                                        onChange={(e) => {
                                                            this.updateValue('previewTitle', e.target.value)
                                                        }}/>
                                                </div>
                                                <div className="form-group m-lg-b ad-media-container">
                                                    <span className="label">Ad Media</span>
                                                    <div className='horizontal'>
                                                        <button onClick={() => this.fileInput.click()}
                                                                className="btn-action">
                                                            Upload Photo <i className="fas fa-upload"/>
                                                        </button>
                                                        {this.state.fileUploadActive ?
                                                            <p className="blink-me">Uploading file...</p> : ''}
                                                    </div>
                                                    <input
                                                        style={{display: "none"}} type="file"
                                                        onChange={this.fileSelectedUploadHandler}
                                                        ref={fileInput => this.fileInput = fileInput}
                                                    />
                                                    {this.state.imageHashUrl && this.state.imageName ?
                                                        <div className="uploaded-image-container">
                                                            <div className='left-part'>
                                                                <img src={this.state.imageHashUrl}/>
                                                                <p>{this.state.imageName}</p>
                                                            </div>
                                                            <p onClick={() => console.log('Obrisi sliku')}>
                                                                <i className="far fa-times-circle"></i> Remove</p>
                                                        </div>
                                                        : ''
                                                    }
                                                </div>
                                                {/*<div className="form-group m-lg-b fb-spons-message">*/}
                                                    {/*<span className="label">Image Source</span>*/}
                                                    {/*<input*/}
                                                        {/*id='image-source-input'*/}
                                                        {/*className={this.state.loading_title ? "input-loading" : this.state.imageFromLink ? "fb-sponsored-message-input valid" : "fb-sponsored-message-input"}*/}
                                                        {/*placeholder="You can use a fetched default, or change it to a custom title"*/}
                                                        {/*type="text"*/}
                                                        {/*value={this.state.imageFromLink}*/}
                                                        {/*onChange={(e) => {*/}
                                                            {/*this.updateValue('imageLink', e.target.value)*/}
                                                        {/*}}/>*/}
                                                    {/*<i className="fas fa-upload imag-source-icon"/>*/}
                                                {/*</div>*/}
                                            </div>
                                            <CustomSinglePostPreview
                                                messageContent={this.state.messageContent}
                                                loading_title={this.state.loading_title}
                                                previewLink={this.state.imageHashUrl}
                                                previewTitle={this.state.previewTitle}
                                                type={'preview'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.state.activeStep.toString() === '1' ?

                                <span className="label"><label className="checkbox"
                                                               style={{fontSize: 12, width: '100%'}}>
                                        My Ad does not offer housing, employment, or credit opportunities
                                    <Popover
                                    interactionKind={PopoverInteractionKind.HOVER}
                                    position={Position.RIGHT}
                                >
                                             <i
                                                 intent={Intent.PRIMARY}
                                                 style={{color: 'lightgrey'}}
                                                 className="fas fa-question-circle"
                                                 slot={'bidControl'}
                                             ></i>
                                              <Callout
                                                  intent={"danger"}
                                                  icon={'warning-sign'}
                                              >
                                            Facebook does not support the advertising for Housing,
                                                Employment or Credit opportunities within paid Ads campaigns.
                                            </Callout>
                                          </Popover>
                                        <input
                                            id="single" name="single" type="checkbox"
                                            checked={!this.state.specialAdCategory}
                                            onChange={() => this.setState({
                                                specialAdCategory: !this.state.specialAdCategory
                                            })}/>
                                    <span className="checkmark"></span>
                                        </label>
                                    </span>
                                :
                                ''
                            }
                            {this.state.errorMessage ?
                                <div className="error-message-container">

                                    {/*<h3>{ this.state.errorMessage }</h3>*/}
                                    {this.state.listOfErrors.map((error) => {
                                        return <Callout
                                            intent={"danger"}
                                            icon={'warning-sign'}
                                        >
                                            {error}
                                        </Callout>
                                    })}
                                    {/*{this.throwErrorAlert()}*/}
                                </div> : ''
                            }
                            {
                                this.state.specialAdCategory ?
                                    <Callout
                                        intent={"danger"}
                                        icon={'warning-sign'}
                                    >
                                        Facebook does not support the advertising for Housing,
                                        Employment or Credit opportunities within paid Ads campaigns.
                                    </Callout> : ''
                            }
                            {this.state.activeStep.toString() === '1' ?
                                <div className="fb-sponsored-buttons-container">
                                    <button onClick={() => this.props.history.push('/new')}
                                            className='btn-transparent-border btn-t m-xl-b'>
                                        Cancel
                                    </button>
                                    {!this.state.spinnerActive ?
                                        <button
                                            // disabled={ this.nextButtonDisabled() }
                                            onClick={() => this.nextButtonDisabled() ? this.checkErrors() : this.nextClicked()}
                                            className={this.nextButtonDisabled() ? "btn btn-transparent-border btn-t m-xl-b" : "btn btn-action btn-t m-xl-b"}
                                        >
                                            Next
                                        </button>
                                        :
                                        <button disabled className='btn-transparent-border btn-t m-xl-b'>
                                            Next <i className='fa fa-spin fa-spinner'></i>
                                        </button>
                                    }
                                </div>
                                :
                                <div className="fb-sponsored-buttons-container">
                                    <button onClick={this.previousClicked}
                                            className='btn-transparent-border btn-t m-xl-b'>
                                        Previous
                                    </button>
                                    {!this.state.spinnerActive ?
                                        <button
                                            onClick={() => this.createCampaignButtonDisabled() ? this.checkErrors() : this.adCreative()}
                                            className={this.createCampaignButtonDisabled() ? "btn btn-transparent-border btn-t m-xl-b" : "btn btn-action btn-t m-xl-b"}
                                        >
                                            Create Campaign
                                        </button>
                                        :
                                        <button disabled className='btn-transparent-border btn-t m-xl-b'>
                                            Create Campaign <i className='fa fa-spin fa-spinner'></i>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                        :
                        <div className="campaign-performance-no-account-id-container">
                            <h3>In order to see Facebook Sponsored Messages, Emitto needs the permission to access your
                                Facebook Ads Manager. Make sure you grant this permission by clicking on
                                the 'Enable Facebook Campaigns</h3>
                            <FacebookLogin
                                appId={facebook_app_id}
                                autoLoad={false}
                                return_scopes={true}
                                fields="name, email, picture"
                                scope="email, public_profile, pages_messaging, ads_management, pages_read_engagement"
                                callback={this.responseFacebook}
                                render={renderProps => (
                                    <div className="row">
                                        <button
                                            id="ask_denied_permissions"
                                            onClick={renderProps.onClick}
                                            className="btn-fb m-m-b"
                                            style={{
                                                // float: "right",
                                                marginTop: "0 auto"
                                            }}>
                                            <span className="fas fa-sync"></span> Enable Facebook Campaigns
                                        </button>
                                    </div>
                                )}/>
                        </div>
                }
            </div>
        </React.Fragment>
    }
}

export default FacebookSponsoredMessage;